import { render } from "./ApplyLeave.vue?vue&type=template&id=cc471b4a"
import script from "./ApplyLeave.vue?vue&type=script&lang=js"
export * from "./ApplyLeave.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__